// Implements: F-IDN-012
/**
 * Which `422` of `POST /auth/password-change` is the password policy refusing the NEW password.
 *
 * The backend answers two different `422 VALIDATION`s on this route with the same envelope and no
 * public `details`: the policy (`identity/domain/password_policy.py`, one sentence per clause) and
 * the request schema (`platform/infrastructure/http/errors.py`, "La solicitud no es válida.", for
 * instance an over-long current password). The sentence is the only thing that tells them apart,
 * so the rule is an allowlist of the policy's three sentences: only those go under the new-password
 * field; any other `422` is said for the whole form. A reworded policy sentence therefore degrades
 * to a form-level message, never to a wrong field.
 */

/** The backend's `TOO_SHORT`, `EDGE_WHITESPACE` and `SAME_AS_CURRENT`, word for word. */
export const PASSWORD_POLICY_REFUSALS: ReadonlySet<string> = new Set([
  "La contraseña debe tener al menos 12 caracteres.",
  "La contraseña no puede empezar ni terminar con espacios.",
  "La contraseña nueva debe ser distinta de la actual.",
]);

/** What the rule reads of a refusal: the `ApiError` fields, without importing the API layer. */
export interface Refusal {
  readonly status: number;
  readonly code: string;
  readonly message: string;
}

/** Whether `error` is the policy refusing the new password (and not any other `422`). */
export function isPolicyRefusal(error: Refusal): boolean {
  return error.status === 422 && error.code === "VALIDATION" && PASSWORD_POLICY_REFUSALS.has(error.message);
}
